import { useEffect } from 'react';
import { useStore } from '@tmsw/powerups.store';

export default function useScoreboard() {
  const setScore = useStore((state) => state.setScore);
  const streakCount = useStore((state) => state.streakCount);
  const resetStreak = useStore((state) => state.resetStreak);
  const score = useStore((state) => state.score);
  const hitsCount = useStore((state) => state.hitsCount);
  const movesCount = useStore((state) => state.movesCount);
  const hitsPercentage = useStore((state) => state.hitsPercentage);
  const progressPercentage = useStore((state) => state.progressPercentage);
  const setMovesCount = useStore((state) => state.setMovesCount);
  const setHitsCount = useStore((state) => state.setHitsCount);
  const setHitsPercentage = useStore((state) => state.setHitsPercentage);
  const setProgressPercentage = useStore(
    (state) => state.setProgressPercentage
  );

  /**
   * Reset the scoreboard
   */
  // useEffect(() => {
  //   if (!needsReset) return;
  //   console.log('resetting scoreboard');
  //   setScore(0);
  //   setMovesCount(0);
  //   resetStreak();
  //   setHitsCount(0);
  //   setHitsPercentage(0);

  //   return () => {
  //     console.trace('cleanup resetting scoreboard');
  //   };
  // }, [needsReset]);

  /**
   * Calculate the percent completion of the level
   */
  useEffect(() => {
    setProgressPercentage((hitsCount / 25) * 100);
  }, [hitsCount, setProgressPercentage]);

  /**
   * Calculate the hitCount/moveCount ratio
   */
  useEffect(() => {
    setHitsPercentage((hitsCount / movesCount) * 100);
  }, [hitsCount, movesCount, setHitsPercentage]);

  const resetGameboard = () => {
    setScore(0);
    setMovesCount(0);
    resetStreak();
    setHitsCount(0);
    setHitsPercentage(0);
    setProgressPercentage(0);
  };

  return {
    score,
    movesCount,
    hitsCount,
    hitsPercentage,
    progressPercentage,
    streakCount,
    setScore,
    resetGameboard,
  };
}
